/**
 * Collection/search page: price-range slider (noUiSlider) + grid/list layout switcher.
 * Filtering itself is plain links to Shopify's native filter URLs (facets.liquid),
 * so it works even without JS — this file only adds the slider UX and layout toggle.
 */
(function () {
  'use strict';

  var moneyFormat = (window.themeVars && window.themeVars.moneyFormat) || '${{amount}}';
  function formatMoney(amount) {
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, parseFloat(amount).toFixed(2));
  }

  function initPriceSlider() {
    var wrap = document.querySelector('[data-price-filter]');
    var mount = document.querySelector('#price-value-range');
    if (!wrap || !mount || !window.noUiSlider || mount.noUiSlider) return;

    var min = parseFloat(wrap.getAttribute('data-min')) || 0;
    var max = parseFloat(wrap.getAttribute('data-max')) || 100;
    var currentMin = parseFloat(wrap.getAttribute('data-current-min')) || min;
    var currentMax = parseFloat(wrap.getAttribute('data-current-max')) || max;
    var paramMin = wrap.getAttribute('data-param-min');
    var paramMax = wrap.getAttribute('data-param-max');
    var baseUrl = wrap.getAttribute('data-url');

    window.noUiSlider.create(mount, {
      start: [currentMin, currentMax],
      connect: true,
      range: { min: min, max: max === min ? min + 1 : max }
    });

    var minLabel = document.querySelector('#price-min-value');
    var maxLabel = document.querySelector('#price-max-value');

    mount.noUiSlider.on('update', function (values) {
      if (minLabel) minLabel.textContent = formatMoney(values[0]);
      if (maxLabel) maxLabel.textContent = formatMoney(values[1]);
    });

    mount.noUiSlider.on('change', function (values) {
      var url = new URL(baseUrl, window.location.origin);
      var params = new URLSearchParams(window.location.search);
      params.set(paramMin, values[0]);
      params.set(paramMax, values[1]);
      url.search = params.toString();
      window.location.href = url.toString();
    });
  }

  function initLayoutSwitch() {
    var switches = document.querySelectorAll('.al-view-layout-switch');
    var grid = document.querySelector('[data-product-grid]');
    if (!switches.length || !grid) return;

    // Clears every responsive grid-column class (al-/sm-/md-/lg-col-N) and
    // "list", regardless of how many are present, so a manual layout choice
    // cleanly replaces the default responsive combo (e.g. "al-col-1 sm-col-2
    // md-col-3 lg-col-4") rather than leaving stray classes mixed in.
    function clearLayoutClasses() {
      grid.className = grid.className
        .replace(/\b(al|ssm|sm|md|lg|xl)-col-\d+\b/g, '')
        .replace(/\blist\b/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function applyLayout(value) {
      clearLayoutClasses();
      grid.classList.add(value);
      switches.forEach(function (s) {
        s.classList.toggle('active', s.getAttribute('data-value-layout') === value);
      });
    }

    var saved = null;
    try { saved = window.localStorage.getItem('theme:collection-layout'); } catch (e) {}
    if (saved) applyLayout(saved);

    switches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-value-layout');
        applyLayout(value);
        try { window.localStorage.setItem('theme:collection-layout', value); } catch (e) {}
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPriceSlider();
    initLayoutSwitch();
  });
})();
